import React from "react";

import ECD from "../components/ECD";

const Blueprint = (props) => {

    return (
        <div>
            <div class="container">
                <div class="row">
                    <div className="row customer-support text-center" style={{marginTop: 10}}>
                        <h4 style={{ color: "black" }}>{props.VehEntry.Veh_Year} {props.VehEntry.Veh_Make} {props.VehEntry.Veh_Model}</h4>
                        <p style={{ marginTop: 10, color: "black" }}>Blueprint/Tear Down</p>
                        <p><b>{props.Veh_Year}</b></p>
                    </div>
                </div>
            </div>
            <div className="sec-title text-left" style={{marginTop: 10}}>
                <h4 style={{ color: "black" }}>What does this mean?</h4>
                <span className="decor" />
                <p style={{color: "black"}}>This is the first step when your vehicle arrives at our facility. During this phase, we take all the necessary parts off your vehicle to get a full picture of the damage. We then order any additional parts and begin work. If we wrote or received an estimate prior to receiving your vehicle, this phase should last one day or less. If the vehicle was towed in or if we did not have an estimate before receiving your vehicle, this phase may last one to three days depending on the severity of the damage.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>What is next?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>Following the blueprint/tear down phase, we will order any additional parts that are needed and begin repairs and body work. After the repairs and body work are finished, the vehicle will move to our paint prep area to get ready for the paint booth.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>Estimated Completion Date</h4>
                <span className="decor" />
                <ECD ecd={props.VehEntry.EstimatedCompletionDate} />
            </div>
        </div>
    )
}

export default Blueprint